/**
 * Design-system `Label` severities for the two status vocabularies.
 *
 * Kept beside the vocabularies themselves rather than in the components, so the
 * cycle list and the roster cannot drift into showing the same status in
 * different colours.
 */

/** Cycle status → Label severity. */
export const CYCLE_STATUS_SEVERITY = {
  // Not open yet — informational, nothing to act on.
  pending: 'info',
  // Intake is open; this is the cycle admins are working in.
  active: 'success',
  // Finished and read-only. Deliberately muted rather than an alarm colour.
  complete: 'brand',
};

/** Membership status → Label severity. */
export const MEMBERSHIP_STATUS_SEVERITY = {
  nominee: 'info',
  applicant: 'warning',
  winner: 'success',
  'not-selected': 'error',
  'not-entered': 'info',
};

export const getCycleStatusSeverity = (status) => CYCLE_STATUS_SEVERITY[status] ?? 'info';

export const getMembershipStatusSeverity = (status) =>
  MEMBERSHIP_STATUS_SEVERITY[status] ?? 'info';
